import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ReactComponent as CloseIcon } from 'assets/icons/close-fat.svg';
import { ReactComponent as OkCheck } from 'assets/icons/ok-check.svg';

import { MIN_TABLET } from 'styles/base/breakpoints';

import ModeratorStatus from '../styles/ModeratorStatus';
import StyledModeratorBar from '../styles/StyledModeratorBar';

import { BlueDot } from './elements/BlueDot';
import ButtonCap from './elements/ButtonCap';
import { GreenDot } from './elements/GreenDot';
import { OrangeDot } from './elements/OrangeDot';
import InfoTooltip from '../../../components/InfoTooltip';
import Text from '../../../components/Text';

const Legend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: flex-start;
  align-items: flex-start;
  @media (${MIN_TABLET}) {
    flex-direction: row;
  }
`;

function ModeratorBar() {
  const moderationMode = useSelector(state => state.userData.info.moderation_mode);

  return (
    <StyledModeratorBar className="box">
      <Legend>
        <ButtonCap disabled type="button" background="gray" noWrapper>
          <GreenDot />
          <span>WYŚWIETLONE</span>
          <InfoTooltip
            style={{ position: 'relative', top: -1, left: 10 }}
            content={
              <Text margin="0">
                Status “Wyświetlone” oznacza, że wiadomość została wyświetlona przez widżet.
              </Text>
            }
            placement="right"
            theme="dark"
          />
        </ButtonCap>
        <ButtonCap disabled type="button" background="gray" noWrapper>
          <OrangeDot />
          <span>W KOLEJCE WIADOMOŚCI</span>
          <InfoTooltip
            style={{ position: 'relative', top: -1, left: 10 }}
            content={
              <Text margin="0">
                Status “W kolejce wiadomości” oznacza, że wiadomość oczekuje na wyświetlenie przez
                widżet
                <a href="/konfigurator/powiadomienie-o-wiadomosci"> powiadomienie o wiadomości. </a>
                Jeśli widżet zostanie uruchomiony, a wiadomości wyświetlone, status zmieni się na
                wyświetlone. Ten status nie ma wpływu na bilans konta.
              </Text>
            }
            placement="right"
            theme="dark"
          />
        </ButtonCap>
        <ButtonCap disabled type="button" background="gray" noWrapper>
          <BlueDot />
          <span>OCZEKUJE NA MODERACJĘ</span>
          <InfoTooltip
            style={{ position: 'relative', top: -1, left: 10 }}
            content={
              <Text margin="0">
                Status “Oczekuje na moderację” oznacza, że masz włączoną moderację na swoim koncie.
                Status nie zmieni się, do póki nie zdecydujesz co zrobić z wiadomością za pomocą
                dostępnych przycisków obok wiadomości. Moderację wyłączyć możesz w tym miejscu, za
                pomocą przycisku “Moderacja wiadomości”.
                <a href="https://support.tipply.pl/moderacja-wiadomosci-w-tipplypl/">
                  Czytaj więcej
                </a>
              </Text>
            }
            placement="right"
            theme="dark"
          />
        </ButtonCap>
      </Legend>

      {moderationMode ? (
        <ModeratorStatus>
          <OkCheck fill="var(--brand-green)" />
          <span>MODERACJA AKTYWNA</span>
        </ModeratorStatus>
      ) : (
        <ModeratorStatus>
          <CloseIcon fill="var(--error-color)" />
          <span>MODERACJA NIEAKTYWNA</span>
        </ModeratorStatus>
      )}
    </StyledModeratorBar>
  );
}

export default ModeratorBar;
